/**
 * ActiveBonusBadge — tiny gold pill showing the count of pending/active
 * bonus claims for the current caller.
 *
 * Extracted from AppShell.jsx so both the desktop top-nav pill and the
 * mobile bottom-nav "Promos" tab can share the same fetch/gate. Renders
 * `null` when there are no active claims so callers can drop it in
 * unconditionally without an extra guard.
 *
 * Positioning is up to the caller — pass `className` to override defaults.
 */
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api, { getToken } from "../lib/api";

export default function ActiveBonusBadge({
  className = "absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full bg-gold text-black text-[9px] font-bold flex items-center justify-center shadow-glow-gold",
  testid = "topbar-promo-badge",
}) {
  const [count, setCount] = useState(0);
  const loc = useLocation();
  useEffect(() => {
    // Only authenticated callers have claims. Skipping the fetch on
    // unauthed mounts keeps `MobileBottomNav` (which renders this on
    // the public Landing page) from hitting `/api/bonuses/mine` and
    // triggering a 401.
    if (!getToken()) { setCount(0); return; }
    let alive = true;
    api.get("/bonuses/mine")
      .then(({ data }) => {
        if (!alive) return;
        const active = (data?.items || []).filter(
          (c) => c.status === "pending" || c.status === "active"
        );
        setCount(active.length);
      })
      .catch(() => alive && setCount(0));
    return () => { alive = false; };
  }, [loc.pathname]);
  if (count <= 0) return null;
  return (
    <span className={className} data-testid={testid}>
      {count}
    </span>
  );
}
